import { motion } from 'framer-motion'
import { DURATION, EASE_OUT } from '../tokens/motion'
import { cn } from '../lib/cn'

/**
 * Measured progress, and only measured progress. Studio's rule is that a
 * wait reports activity, never an invented fraction. A byte count is a real
 * measurement, so it gets a bar. Without a value the bar sweeps instead.
 */
export function ProgressBar({
  value,
  tone = 'default',
  label,
  className,
}: {
  /** 0 to 1, or null when the work has no measurable size. */
  value: number | null
  tone?: 'default' | 'attention' | 'muted'
  label: string
  className?: string
}) {
  const fill = tone === 'attention' ? 'bg-danger' : tone === 'muted' ? 'bg-muted-foreground/50' : 'bg-foreground'
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value === null ? undefined : Math.round(value * 100)}
      className={cn('relative h-[3px] w-full overflow-hidden rounded-full bg-selected', className)}
    >
      {value === null ? (
        <div className="wf-indeterminate absolute inset-0 text-foreground/60" />
      ) : (
        <motion.div
          className={cn('absolute inset-y-0 left-0 rounded-full', fill)}
          initial={false}
          animate={{ width: `${Math.max(0, Math.min(1, value)) * 100}%` }}
          transition={{ duration: DURATION.slow, ease: EASE_OUT }}
        />
      )}
    </div>
  )
}
